import { Paper, Stack, Typography } from '@mui/material'
import { rateLabel } from './submissionRate'
import { styles } from './SummaryTiles.styles'

export interface MetricSummary {
  submissionRate: number | null
  totalForms: number
  submitted: number
  inProgress: number
}

interface TileSpec {
  label: string
  color: string
  testId: string
  of: (metrics: MetricSummary) => string | number
}

const TILES: TileSpec[] = [
  { label: 'Submission Rate', color: 'primary.main', testId: 'p2pOverviewRate', of: metrics => rateLabel(metrics.submissionRate) },
  { label: 'Total Forms', color: 'secondary.main', testId: 'p2pStatTotalForms', of: metrics => metrics.totalForms },
  { label: 'Submitted', color: 'success.main', testId: 'p2pStatSubmitted', of: metrics => metrics.submitted },
  { label: 'In Progress', color: 'warning.main', testId: 'p2pStatInProgress', of: metrics => metrics.inProgress }
]

export const SummaryTiles = ({ metrics }: { metrics: MetricSummary }): JSX.Element => (
  <Stack direction='row' gap='16px' flexWrap='wrap' sx={styles.row}>
    {TILES.map(tile => (
      <Paper key={tile.label} variant='outlined' sx={styles.tile} data-testid={tile.testId}>
        <Typography variant='h2' sx={styles.value(tile.color)}>{tile.of(metrics)}</Typography>
        <Typography variant='body2' sx={styles.label}>{tile.label}</Typography>
      </Paper>
    ))}
  </Stack>
)

/** The same four metrics for one org, sized to sit inside an expanded drill row. */
export const CompactSummaryTiles = ({ metrics }: { metrics: MetricSummary }): JSX.Element => (
  <Stack direction='row' gap='12px' flexWrap='wrap' sx={styles.compactRow}>
    {TILES.map(tile => (
      <Paper key={tile.label} variant='outlined' sx={styles.compactTile}>
        <Typography sx={styles.compactValue(tile.color)}>{tile.of(metrics)}</Typography>
        <Typography variant='caption' sx={styles.compactLabel}>{tile.label}</Typography>
      </Paper>
    ))}
  </Stack>
)
